import * as React from 'react';
import { Flex, Layout, Menu, Tabs } from 'antd';
// import CreateUpdateBin from './CreateUpdateBin';
import GrowerAdministration from './GrowerAdminstration';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import BinInfoDTO from 'src/models/BinInfoDTO';
// import { UpdateDeviceV2 } from './UpdateDeviceV2';
import { UpdateDeviceV3 } from './UpdateDeviceV3';
import { AddBoardLookup } from './AddBoardLookup';
import { AddSoftwareLookup } from './AddSoftwareLookup';
import RoleUtil from 'src/utils/RoleUtil';
import { CreateUpdateBinV2 } from './CreateUpdateBinV2';
import IoTDevices from './IoTDevices';
import { SettingOutlined, UserOutlined } from '@ant-design/icons';


export interface AdminTabsProps {
    tab?: number;
}

export type adminHistoryState = {
    passedBin?: BinInfoDTO;
    passedGrower?: [number, string];
};

const AdminTabs = (props: AdminTabsProps) => {
    const location = useLocation<adminHistoryState>();
    const history = useHistory();
    const params = useParams();


    const selectedMainKey = () => {
        if ([2, 6, 7].includes(props.tab!)) {
            return "advanced";
        }
        return "user";
    }

    const mainItems = [
        {
            key: 'user',
            icon: <UserOutlined />,
            label: 'User Setup'
        },
        {
            key: 'advanced',
            icon: <SettingOutlined />,
            label: 'Advanced'
        }
    ];

    return (
        <Layout.Content className='admin' key={props.tab}>
            <Flex gap={8}>
                <Menu onClick={(e) => {
                    if (e.key === selectedMainKey()) {
                        return;
                    }
                    if (e.key == "user") {
                        history.push(`/admin/${1}`)
                    }
                    else {
                        history.push(`/admin/${2}`)
                    }

                }} mode="vertical" selectedKeys={[selectedMainKey()]} items={mainItems} style={{ width: 188 }} />
                {selectedMainKey() === "user" && <Tabs activeKey={props.tab ? props.tab.toString() : '1'}
                    onChange={(key) => {
                        history.push(`/admin/${key}`)
                    }}
                    style={{ width: '100%' }}
                >
                    <Tabs.TabPane tab="Organizations" key="1">
                        <GrowerAdministration isSettings={false} />
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Bins" key="3">
                        <CreateUpdateBinV2 />
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="System Configurations" key="5">
                        <UpdateDeviceV3 />
                    </Tabs.TabPane>

                </Tabs>
                }
                {selectedMainKey() === "advanced" && (
                    <Tabs activeKey={props.tab ? props.tab.toString() : '1'}
                    onChange={(key) => {
                        history.push(`/admin/${key}`)
                    }}
                    style={{ width: '100%' }}
                >

                    <Tabs.TabPane tab="IoT Devices" key="2">
                        <IoTDevices />
                    </Tabs.TabPane>

                    <Tabs.TabPane tab="Add PCB Lookup" key="6">
                        <AddBoardLookup />
                    </Tabs.TabPane>


                </Tabs>
                )}
            </Flex>
        </Layout.Content>
    );
};

export default AdminTabs;
